export const useMedicationStore = defineStore('medication', () => {
  const wciaDescription = ref('')

  return {
    wciaDescription,
  }
})
